// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-MenuIcon_cls1__N-4Q4","cls2":"VeloActionBar-MenuIcon_cls2__N306U VeloActionBar-MenuIcon_cls1__N-4Q4"};